import type { DestroyOptions } from '../../types';
import { TextAsset } from './TextAsset';

export class TimeAwareTextAsset extends TextAsset {
    /**
     TimeAwareTextAsset is a primitive text object that makes adding animations to TextAssets
     simple through the graphical_style property. If the text doesn't need to animate or move, look
     at TextAsset.
    **/
    override _classType = 'TimeAwareTextAsset';

    override destroy(options?: DestroyOptions) {
        super.destroy(options);
        this.clearAnimation();
    }
}
